import { db } from "../firebaseClient";
import { collection, getDocs, query, where } from "firebase/firestore";

const COLLECTION_NAME = "seller_communications";
const CHANNEL_EMAIL = "email";
const COMM_CLASS_CUSTOMER_DIRECT = "customer-direct";
const COMM_SUBCLASS_AUTH_PRICE_WARNING = "auth-price-warning";
const TYPE_OUTBOUND = "outbound";

const getSellerComms = async (identifiers: string[], tenant: string) => {
  const q = query(
    collection(db, COLLECTION_NAME),
    where("tenant", "==", tenant),
    where("sellerIdentifiers", "array-contains-any", identifiers),
    where("type", "==", TYPE_OUTBOUND),
    where("channel", "==", CHANNEL_EMAIL),
    where("commClass", "==", COMM_CLASS_CUSTOMER_DIRECT),
    where("commSubClass", "==", COMM_SUBCLASS_AUTH_PRICE_WARNING)
  );
  const querySnapshot = await getDocs(q);
  const sellerComms = querySnapshot.docs.map((doc) => doc.data());
  return sellerComms;
};

export {
  getSellerComms,
  CHANNEL_EMAIL,
  COMM_CLASS_CUSTOMER_DIRECT,
  COMM_SUBCLASS_AUTH_PRICE_WARNING,
};
